import { MdOutlineCloudUpload } from "react-icons/md";
import { TbNotes } from "react-icons/tb";

import { PiUsersBold, PiTelegramLogo } from "react-icons/pi";
import { AiOutlineHome } from "react-icons/ai";
import { MdMailOutline } from "react-icons/md";
import { CiSettings } from "react-icons/ci";
import { TiDocumentText } from "react-icons/ti";

export const Config: any = [
    {
        Name: "Home",
        Icon: AiOutlineHome,
        Link: "/auth/Dashboard",
        isMultiple: false,
    },
    {
        Name: "Basic Info",
        Icon: PiUsersBold,
        Link: "/basic-info",
        isMultiple: true,
        subMenu: [
            {
                Name: "Personal Info",
                Link: "/auth/basic-info/Profile-info",
            },
            {
                Name: "Dependent Info",
                Link: "/auth/basic-info/dependent-info",
            },
            {
                Name: "Bank Details",
                Link: "/auth/basic-info/bank-details",
            },
            {
                Name: "FBAR",
                Link: "/auth/basic-info/fbar",
            },
        ],
    },
    {
        Name: "other Information",
        Icon: PiUsersBold,
        Link: "/other-information/other-income",

        isMultiple: true,
        subMenu: [
            {
                Name: "other Income",
                Link: "/auth/other-info/other-income",
            },
            {
                Name: "Expense",
                Link: "/auth/other-info/expense",
            },
            {
                Name: "contributions",
                Link: "/auth/other-info/contributions",
            },
            {
                Name: "Rental income",
                Link: "/auth/other-info/rental-income",
            },
        ],
    },

    {
        Name: "Upload Document",
        Icon: MdOutlineCloudUpload,
        Link: "/auth/upload-document",
        isMultiple: false,
    },
    {
        Name: "Review Document",
        Icon: MdOutlineCloudUpload,
        Link: "/auth/review-doc",
        isMultiple: false,
    },
    {
        Name: "Tax Summary",
        Icon: TbNotes,
        Link: "/auth/Tax-Summary",
        isMultiple: false,
    },
    {
        Name: "Message",
        Icon: MdMailOutline,
        Link: "/auth/message",
        isMultiple: false,
    },
    {
        Name: "Referral",
        Icon: PiTelegramLogo,
        Link: "/auth/referral",
        isMultiple: false,
    },
    {
        Name: "Settings",
        Icon: CiSettings,
        Link: "/auth/settings",
        isMultiple: false,
    },

    {
        Name: "Previous Year Docs",
        Icon: TiDocumentText,
        Link: "/auth/previous-doc",
        isMultiple: false,
    },
];
